import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router';
import { useProposalTemplates } from '../../../data-access/proposalTemplate';
import ProposalTemplateDetail from './ProposalTemplateDetail';

const ProposalTemplateDetailOptionView: React.FC = () => {
  const { proposalTemplateId, proposalTemplateOptionId } = useParams<{
    proposalTemplateId: string;
    proposalTemplateOptionId: string;
  }>();

  const { proposalTemplates } = useProposalTemplates();

  const proposalTemplatesOptions = useMemo(
    () =>
      proposalTemplates
        .filter((d) => d.proposalTemplateId === proposalTemplateId)
        .flatMap((d) => d.options),

    [proposalTemplateId, proposalTemplates]
  );

  const proposalTemplateOptionsFiltered = useMemo(
    () =>
      proposalTemplatesOptions.filter(
        (o) => o.proposalTemplateOptionId === proposalTemplateOptionId
      ),
    [proposalTemplateOptionId, proposalTemplatesOptions]
  );

  const firstOption =
    !proposalTemplateOptionId && proposalTemplatesOptions.at(0);
  if (firstOption) {
    return (
      <Navigate
        to={`option/${firstOption.proposalTemplateOptionId}`}
        replace={true}
      />
    );
  }

  return proposalTemplateOptionsFiltered.map((option) => (
    <ProposalTemplateDetail
      key={option.proposalTemplateOptionId}
      proposalTemplateOption={option}
    />
  ));
};

export default ProposalTemplateDetailOptionView;
